/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */
import { faker } from '@faker-js/faker';
import type { RequestHandlerOptions } from 'msw';
import { delay, HttpResponse, http } from 'msw';

import type {
  IdResponse,
  SuccessResponse,
  TenantUserDetailResponse,
  TenantUserListResponse,
} from './model';

export const getListUsersResponseMock = (): TenantUserListResponse => ({
  items: [
    {
      id: '22222222-2222-2222-2222-222222222222',
      name: 'テストユーザー',
      email: 'wisevine_dev_admin@wise-vine.com',
      divisions: [
        { id: 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa', code: '001', name: '企画財政課', year: 2024 },
      ],
      role: 'admin',
      role_display_name: '管理者',
      is_active: true,
      last_login: '2024-01-15T10:30:00Z',
      is_self: false,
    },
    {
      id: '22222222-2222-2222-2222-222222222223',
      name: '編集者ユーザー',
      email: 'editor@wise-vine.com',
      divisions: [
        { id: 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa', code: '001', name: '企画財政課', year: 2024 },
        { id: 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb', code: '002', name: '総務課', year: 2024 },
      ],
      role: 'editor',
      role_display_name: '編集者',
      is_active: true,
      last_login: null,
      is_self: false,
    },
  ],
  total: 2,
});

export const getCreateUserResponseMock = (
  overrideResponse: Partial<IdResponse> = {},
): IdResponse => ({ id: faker.string.uuid(), ...overrideResponse });

export const getGetUserResponseMock = (): TenantUserDetailResponse => ({
  id: '22222222-2222-2222-2222-222222222222',
  name: 'テストユーザー',
  email: 'wisevine_dev_admin@wise-vine.com',
  divisions: [
    { id: 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa', code: '001', name: '企画財政課', year: 2024 },
    { id: 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb', code: '002', name: '総務課', year: 2024 },
  ],
  role: 'admin',
  role_display_name: '管理者',
  is_active: true,
  last_login: '2024-01-15T10:30:00Z',
});

export const getUpdateUserResponseMock = (): SuccessResponse => ({ success: true });

export const getResetUserPasswordResponseMock = (): SuccessResponse => ({ success: true });

export const getListUsersMockHandler = (
  overrideResponse?:
    | TenantUserListResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<TenantUserListResponse> | TenantUserListResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/tenants/users',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getListUsersResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getCreateUserMockHandler = (
  overrideResponse?:
    | IdResponse
    | ((info: Parameters<Parameters<typeof http.post>[1]>[0]) => Promise<IdResponse> | IdResponse),
  options?: RequestHandlerOptions,
) => {
  return http.post(
    '*/tenants/users',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getCreateUserResponseMock(),
        ),
        { status: 201, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getGetUserMockHandler = (
  overrideResponse?:
    | TenantUserDetailResponse
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) => Promise<TenantUserDetailResponse> | TenantUserDetailResponse),
  options?: RequestHandlerOptions,
) => {
  return http.get(
    '*/tenants/users/:userId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getGetUserResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getUpdateUserMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/tenants/users/:userId',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateUserResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};

export const getResetUserPasswordMockHandler = (
  overrideResponse?:
    | SuccessResponse
    | ((
        info: Parameters<Parameters<typeof http.patch>[1]>[0],
      ) => Promise<SuccessResponse> | SuccessResponse),
  options?: RequestHandlerOptions,
) => {
  return http.patch(
    '*/tenants/users/:userId/reset-password',
    async (info) => {
      await delay(1000);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === 'function'
              ? await overrideResponse(info)
              : overrideResponse
            : getResetUserPasswordResponseMock(),
        ),
        { status: 200, headers: { 'Content-Type': 'application/json' } },
      );
    },
    options,
  );
};
export const getDnRAPIMock = () => [
  getListUsersMockHandler(),
  getCreateUserMockHandler(),
  getGetUserMockHandler(),
  getUpdateUserMockHandler(),
  getResetUserPasswordMockHandler(),
];
